module.exports = __webpack_public_path__ + "static/media/banner_img.d852f421.svg";